import { createTheme, alpha } from '@mui/material';
const theme = createTheme({
  palette: {
    primary: {
      main: '#0F3C6D', // Deep, professional Calm Tech Blue
      light: '#255A9C',
      dark: '#08254A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FDB813', // Warm, energetic but not blinding Yellow
      light: '#FDD05E',
      dark: '#D99B0B',
      contrastText: '#000000',
    },
    background: {
      default: '#F5F7FA', // Very subtle cool tint for "Calm Tech" backgrounds
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A2B4C', // Deep blue-gray instead of pure black
      secondary: '#4A5B7C', // Softer blue-gray for secondary text
    },
    success: {
      main: '#2E7D32',
      lightest: alpha('#2E7D32', 0.08),
    },
    error: {
      main: '#D32F2F',
      lightest: alpha('#D32F2F', 0.08),
      lighter: alpha('#D32F2F', 0.12),
    },
    info: {
      main: '#0288D1',
      lightest: alpha('#0288D1', 0.08),
    },
  },
  shape: {
    borderRadius: 12, // Softer UI elements (Calm Tech)
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Modern, approachable
          fontWeight: 600,
          boxShadow: 'none',
          transition: 'transform 0.25s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.25s cubic-bezier(0.25, 1, 0.5, 1), background-color 0.25s',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(15, 60, 109, 0.12)', // Subtle depth
            transform: 'translateY(-1.5px)',
          },
          '&:active': {
            transform: 'scale(0.97)',
          }
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          boxShadow: '0 2px 12px rgba(15, 60, 109, 0.06)', // Calm, bluish shadow
        },
        elevation3: {
          boxShadow: '0 8px 24px rgba(15, 60, 109, 0.12)',
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: '1px solid rgba(15, 60, 109, 0.1)',
        }
      }
    }
  },
  typography: {
    fontFamily: [
      '"Inter"',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, letterSpacing: '-0.02em' },
    h3: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, letterSpacing: '-0.01em' },
    h4: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700 },
    h5: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 600 },
    subtitle1: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 600 },
    subtitle2: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 600 },
    button: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 600 },
    overline: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 700, letterSpacing: '0.1em' },
  },
});

export default theme;